module.exports = __webpack_public_path__ + "img/logo2.100ae593.png";